import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const editProductsData = createAsyncThunk(
  "editProductsData",
  async (formData) => {
    console.log(formData);
    const tokenData = localStorage.getItem("access_token");
    try {
      var { data } = await axios({
        method: "post",
        url: "https://api.cricway.live/api/v1/productDetails/updateProduct/prodsysonefourseven/update/edit/product/details",
        data: formData,
        headers: {
          authorization: `bearer ${tokenData}`,
          "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        },
      });
      return data;
    } catch (err) {
      return err;
    }
  }
);

const editProductsSlice = createSlice({
  name: "editProducts",
  initialState: {
    data: [],
    pending: true,
    error: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(editProductsData.pending, (state) => {
        state.pending = true;
      })
      .addCase(editProductsData.fulfilled, (state, action) => {
        state.pending = false;
        state.data = action.payload;
        state.error = false;
      })
      .addCase(editProductsData.rejected, (state, action) => {
        state.pending = false;
        state.data = [];
        state.error = action.error.message;
      });
  },
});

export default editProductsSlice.reducer;
